let baseURL = '';
if (process.env.NODE_ENV === 'development') {
  //测试环境境
  baseURL = 'https://academy-api.gymooit.cn/v1';
} else {
  //正式环境
  baseURL = 'https://academy-api.gymooit.cn/v1';
}
export const urlDomain = baseURL
export default baseURL;
/* 测试：https://academy-api.gymooit.cn */
/* 正式：https://xmg-service-api.zyqylyjt.cn */
